import React from 'react';
import { Crown20Filled } from '@fluentui/react-icons';
import { CHAT_ICON_COLOR } from './ChatIcons.constants';

export const ChatIconsAdmin = () => {
  return <Crown20Filled color={CHAT_ICON_COLOR} aria-hidden="true" />;
};
